import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import PraisesList from "../Components/PraisesList";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./Praises.css";

function Praises() {
  const [isLoading, setIsLoading] = useState(true);
  const [receivedPraises, setReceivedPraises] = useState([]);
  const [sentPraises, setSentPraises] = useState([]);
  const [managerPraises, setManagerPraises] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedPraise, setSelectedPraise] = useState(null);
  const [key, setKey] = useState("received");

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/praises/received/user/${state.userId}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setReceivedPraises(response.data.receivedPraises);
      setSentPraises(response.data.sentPraises);
      setManagerPraises(response.data.managerPraises);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId]);

  const handleClose = () => setShow(false);

  const handleShow = (id) => {
    setShow(true);
    setSelectedPraise(id);
  };

  const deletePraise = async (id) => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/praises/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/praises/received/user/${state.userId}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setReceivedPraises(response.data.receivedPraises);
      setSentPraises(response.data.sentPraises);
      setManagerPraises(response.data.managerPraises);
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="values-header">
            <h2>{t("Reconocimientos.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right values-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/praises/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Reconocimientos.NuevoReconocimiento")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            <Tab eventKey="received" title="Recibidos">
              {receivedPraises.length === 0 ? (
                <Col className="empty-values center">
                  <h5>{t("Reconocimientos.SinReconocimientos")}</h5>
                </Col>
              ) : (
                <PraisesList
                  praises={receivedPraises}
                  userId={state.userId}
                  language={state.language}
                />
              )}
            </Tab>
            <Tab eventKey="sent" title="Enviados">
              {sentPraises.length === 0 ? (
                <Col className="empty-values center">
                  <h5>{t("Reconocimientos.SinReconocimientos")}</h5>
                </Col>
              ) : (
                <PraisesList
                  praises={sentPraises}
                  userId={state.userId}
                  handleShow={handleShow}
                  language={state.language}
                />
              )}
            </Tab>
            <Tab eventKey="manager" title="Mi equipo">
              {managerPraises.length === 0 ? (
                <Col className="empty-values center">
                  <h5>{t("Reconocimientos.SinReconocimientos")}</h5>
                </Col>
              ) : (
                <PraisesList
                  praises={managerPraises}
                  userId={state.userId}
                  language={state.language}
                />
              )}
            </Tab>
          </Tabs>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Reconocimientos.Reconocimiento.DeletePraise.Titulo")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Reconocimientos.Reconocimiento.DeletePraise.Pregunta")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Reconocimientos.Reconocimiento.DeletePraise.Cancelar")}
            </Button>
            <Button
              variant="danger"
              onClick={() => deletePraise(selectedPraise)}
            >
              {t("Reconocimientos.Reconocimiento.DeletePraise.Eliminar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default Praises;
